import { render, staticRenderFns } from "./AnnualReportList.vue?vue&type=template&id=152dc83d&scoped=true&"
import script from "./AnnualReportList.vue?vue&type=script&lang=ts&"
export * from "./AnnualReportList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "152dc83d",
  null
  
)

export default component.exports